import React, { useEffect, useRef, useState } from "react";
import "./contact.css";
import emailjs from "emailjs-com";

const Contact = () => {
  const isDevelopment = process.env.NODE_ENV !== "production";
  const [status, setStatus] = useState({ type: "", text: "" });
  const [isSending, setIsSending] = useState(false);
  const [copied, setCopied] = useState(false);
  const messageTimer = useRef(null);
  const form = useRef();
  const email = "mustafazeb381@gmail.com";

  const showTemporaryStatus = (type, text) => {
    if (messageTimer.current) clearTimeout(messageTimer.current);
    setStatus({ type, text });
    messageTimer.current = setTimeout(() => setStatus({ type: "", text: "" }), 4000);
  };

  useEffect(() => () => messageTimer.current && clearTimeout(messageTimer.current), []);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      showTemporaryStatus("error", "Could not copy email.");
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true);
    emailjs
      .sendForm("service_p2io8ln", "template_cnuqr7e", form.current, "M3cSai0jPBuO1Yrh1")
      .then(() => {
        form.current.reset();
        showTemporaryStatus("success", "Thanks — I’ll get back to you shortly.");
      }, (error) => {
        if (isDevelopment) console.error("EmailJS send failed:", error);
        showTemporaryStatus("error", "Message could not be sent. Please try again.");
      })
      .finally(() => setIsSending(false));
  };

  return (
    <section id="contact" className="section contact">
      <div className="container contact__grid">
        <div>
          <p className="section__label">
            <span>06</span> — Contact
          </p>
          <h2 className="section__title">Have something worth building? Let&apos;s talk.</h2>
          <p className="section__lead">
            Open to full-time roles, contract work, and freelance projects — remote or on-site.
            The fastest way to reach me is email.
          </p>

          <div className="contact__email-row">
            <a href={`mailto:${email}`} className="contact__email">
              {email}
            </a>
            <button type="button" className="btn" onClick={copyEmail}>
              {copied ? "Copied" : "Copy"}
            </button>
          </div>

          <div className="contact__actions">
            <a href={`mailto:${email}`} className="btn btn-primary">
              Send an email
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=966503111669"
              className="btn"
              target="_blank"
              rel="noreferrer"
            >
              Message on WhatsApp
            </a>
          </div>

          <dl className="contact__meta">
            <div>
              <dt>Location</dt>
              <dd>Riyadh, Saudi Arabia</dd>
            </div>
            <div>
              <dt>Timezone</dt>
              <dd>AST · UTC+3</dd>
            </div>
            <div>
              <dt>Phone</dt>
              <dd>+966 50 311 1669</dd>
            </div>
            <div>
              <dt>Languages</dt>
              <dd>English · Urdu</dd>
            </div>
          </dl>
        </div>

        <form ref={form} onSubmit={sendEmail} className="contact__form">
          <label>
            <span>Name</span>
            <input type="text" name="name" placeholder="Your full name" required />
          </label>
          <label>
            <span>Email</span>
            <input type="email" name="email" placeholder="you@company.com" required />
          </label>
          <label>
            <span>Message</span>
            <textarea name="message" placeholder="What are we building?" rows="6" required />
          </label>
          <button type="submit" className="btn btn-primary" disabled={isSending}>
            {isSending ? "Sending..." : "Send message"}
          </button>
          {status.text && (
            <p className={`contact__status${status.type === "error" ? " is-error" : ""}`}>
              {status.text}
            </p>
          )}
        </form>
      </div>

      <div className="contact__marquee" aria-hidden="true">
        <div className="contact__track">
          {["Available for work", "React Native", "React", "Next.js", "Remote or on-site"].flatMap(
            (item) => [item, item]
          ).map((item, i) => (
            <span key={`${item}-${i}`}>
              {item} <i>◆</i>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
